import { AbstractControl, ValidationErrors } from '@angular/forms';

export function cepValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;

  if (!value) return null;

  const cepMaskRegex = /^\d{5}-\d{3}$/;

  if (!cepMaskRegex.test(value)) {
    return { invalidCep: true };
  }

  return null;
}
